<!-- 
程式：diffWordPropertyLiability.vue
功能：產險難字
作者：00791643 梁惟勝
完成：2020-10-08
-->
<template>
  <main class="container-fluid">
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{ active: currentTab === 0 }">
            <a
              href="#tab-0"
              @click.prevent="resetValid"
              class="nav-link active show"
              role="tab"
              data-toggle="tab"
              >新增難字</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentTab === 1 }">
            <a
              href="#tab-1"
              @click.prevent="resetValid"
              class="nav-link"
              role="tab"
              data-toggle="tab"
              >更新難字</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentTab === 2 }">
            <a
              href="#tab-2"
              @click.prevent="resetValid"
              class="nav-link"
              role="tab"
              data-toggle="tab"
              >查詢紀錄</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="tab-content">
      <div id="tab-0" class="tab-pane active show" role="tabpanel">
        <form
          class="form"
          data-vv-scope="formInsert"
          :class="{ 'section-loading': ajaxLoading1 }"
        >
          <section class="segment">
            <h4 class="text-green mt-0">STEP1 : 新增國泰產險客戶難字設定檔</h4>
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="ID" class="col-2 text-right">客戶ID</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="ID"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('formInsert.ID') }"
                      class="form-control"
                      v-model="formInsert.ID"
                      maxlength="20"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formInsert.ID')"
                    >
                      客戶ID不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="NAME" class="col-2 text-right">客戶姓名</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="NAME"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('formInsert.NAME') }"
                      class="form-control"
                      v-model="formInsert.NAME"
                      maxlength="100"
                      alt="ch"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formInsert.NAME')"
                    >
                      客戶姓名不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="FORM_NO" class="col-2 text-right">表單編號</label>
                  <div class="col-10 d-flex">
                    <input
                      type="text"
                      name="FORM_NO"
                      class="form-control"
                      v-model="formInsert.FORM_NO"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="MEMO" class="col-2 text-right"
                    >備註(請盡量輸入編輯人員ID)</label
                  >
                  <div class="col-10 d-flex">
                    <input
                      type="text"
                      name="MEMO"
                      class="form-control"
                      v-model="formInsert.MEMO"
                      maxlength="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="button" class="btn btn-primary" @click="doInsert">
                新增
              </button>
            </div>
          </section>
        </form>
        <!--
        <form
          class="form"
          data-vv-scope="formDelete"
          :class="{ 'section-loading': ajaxLoading3 }"
        >
          <section class="segment">
            <h4 class="text-green mt-0">刪除國泰產險客戶姓名難字設定檔</h4>
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="ID_Del" class="col-2 text-right">客戶ID</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="ID_Del"
                      v-validate="'required'"
                      :class="{
                        'is-invalid': errors.has('formDelete.ID_Del'),
                      }"
                      class="form-control"
                      v-model="formDelete.ID"
                      maxlength="20"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formDelete.ID_Del')"
                    >
                      客戶ID不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="button" class="btn btn-primary" @click="doDelete">
                刪除
              </button>
            </div>
          </section>
        </form>
        -->
        <form
          class="form"
          data-vv-scope="formUpdateSingle"
          :class="{ 'section-loading': ajaxLoading4 }"
        >
          <section class="segment">
            <h4 class="text-green mt-0">
              STEP2 : 立即更新該客戶姓名至產險相關資料表(一次輸入一筆客戶 ID)
            </h4>
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="ID_One" class="col-2 text-right">客戶ID</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="ID_One"
                      v-validate="'required'"
                      :class="{
                        'is-invalid': errors.has('formUpdateSingle.ID_One'),
                      }"
                      class="form-control"
                      v-model="formUpdateSingle.ID"
                      maxlength="20"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formUpdateSingle.ID_One')"
                    >
                      客戶ID不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-primary"
                @click="doUpdateSingle"
              >
                進行更新(單筆)
              </button>
            </div>
          </section>
        </form>
      </div>
      <div id="tab-1" class="tab-pane" role="tabpanel">
        <form
          class="form"
          data-vv-scope="formUpdate"
          :class="{ 'section-loading': ajaxLoading2 }"
        >
          <section class="segment">
            <h4 class="text-green mt-0">STEP1 : 更新國泰產險客戶難字設定檔</h4>
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="ID_Upt" class="col-2 text-right">客戶ID</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="ID_Upt"
                      v-validate="'required'"
                      :class="{
                        'is-invalid': errors.has('formUpdate.ID_Upt'),
                      }"
                      class="form-control"
                      v-model="formUpdate.ID"
                      maxlength="20"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formUpdate.ID_Upt')"
                    >
                      客戶ID不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="NAME_Upt" class="col-2 text-right"
                    >更新「客戶姓名」</label
                  >
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="NAME_Upt"
                      v-validate="'required'"
                      :class="{
                        'is-invalid': errors.has('formUpdate.NAME_Upt'),
                      }"
                      class="form-control"
                      v-model="formUpdate.NAME"
                      maxlength="100"
                      alt="ch"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formUpdate.NAME_Upt')"
                    >
                      更新「客戶姓名」不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="FORM_NO_Upt" class="col-2 text-right"
                    >更新「表單編號」</label
                  >
                  <div class="col-10 d-flex">
                    <input
                      type="text"
                      name="FORM_NO_Upt"
                      class="form-control"
                      v-model="formUpdate.FORM_NO"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="MEMO_Upt" class="col-2 text-right"
                    >更新「備註」(請盡量輸入編輯人員ID)</label
                  >
                  <div class="col-10 d-flex">
                    <input
                      type="text"
                      name="MEMO_Upt"
                      class="form-control"
                      v-model="formUpdate.MEMO"
                      maxlength="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="button" class="btn btn-primary" @click="doUpdate">
                更新
              </button>
            </div>
          </section>
        </form>
        <form
          class="form"
          data-vv-scope="formUpdateSingle"
          :class="{ 'section-loading': ajaxLoading4 }"
        >
          <section class="segment">
            <h4 class="text-green mt-0">
              STEP2 : 立即更新該客戶姓名至產險相關資料表(一次輸入一筆客戶 ID)
            </h4>
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="ID_One" class="col-2 text-right">客戶ID</label>
                  <div class="col-8 d-flex flex-column">
                    <input
                      type="text"
                      name="ID_One"
                      v-validate="'required'"
                      :class="{
                        'is-invalid': errors.has('formUpdateSingle.ID_One'),
                      }"
                      class="form-control"
                      v-model="formUpdateSingle.ID"
                      maxlength="20"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('formUpdateSingle.ID_One')"
                    >
                      客戶ID不可為空
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-primary"
                @click="doUpdateSingle"
              >
                進行更新(單筆)
              </button>
            </div>
          </section>
        </form>
      </div>

      <div id="tab-2" class="tab-pane" role="tabpanel">
        <form
          class="form"
          data-vv-scope="formSelect1"
          :class="{ 'section-loading': ajaxLoading5 }"
          style="margin-top: 1rem"
        >
          <div class="d-flex align-items-center">
            <label for="ID_One" style="padding-top: 0px"
              >輸入客戶ID&ensp;
            </label>
            <div class="d-flex flex-column" style="margin-right: 5px">
              <input
                type="text"
                name="ID_One"
                v-validate="'required'"
                :class="{
                  'is-invalid': errors.has('formSelect1.ID_One'),
                }"
                class="form-control"
                v-model="formSelect1.ID"
                maxlength="20"
              />
            </div>
            <button
              type="button"
              class="btn btn-primary"
              style="height: 45px"
              @click="doQuery('ID')"
            >
              查詢
            </button>
          </div>
          <div class="row">
            <div
              class="text-danger d-flex"
              v-if="errors.has('formSelect1.ID_One')"
              style="padding-left: 11px"
            >
              &emsp;&emsp;&emsp;&emsp;&emsp;&ensp;客戶ID不可為空
            </div>
          </div>
        </form>

        <hr />

        <form
          class="form"
          data-vv-scope="formSelect2"
          :class="{ 'section-loading': ajaxLoading5 }"
        >
          <div class="d-flex align-items-center">
            <label style="padding-top: 0px">輸入期間&ensp; </label>
            <div>
              <select
                :id="`start-date-year`"
                :data-vv-name="`start-date-year`"
                v-validate="'required'"
                data-vv-as="start-date-year"
                class="form-control form-control-inline"
                :class="{
                  'is-invalid': errors.has(`formSelect2.start-date-year`),
                }"
                v-model="formSelect2.startYear"
              >
                <option value>年份</option>
                <option
                  v-for="(opt, y_opt_i) in yearOpt"
                  :key="`start-year-${y_opt_i}`"
                  :value="opt"
                >
                  {{ opt - 1911 }}年
                </option>
              </select>

              <span class="text">/</span>

              <select
                :id="`start-date-month`"
                :data-vv-name="`start-date-month`"
                v-validate="'required'"
                data-vv-as="start-date-month"
                class="form-control form-control-inline"
                :class="{
                  'is-invalid': errors.has(`formSelect2.start-date-month`),
                }"
                v-model="formSelect2.startMonth"
              >
                <option value>月份</option>
                <option
                  v-for="(opt, m_opt_i) in monthOpt"
                  :key="`start-month-${m_opt_i}`"
                  :value="opt"
                >
                  {{ opt }}月
                </option>
              </select>
              <span class="text"> ~ </span>

              <select
                :id="`end-date-year`"
                :data-vv-name="`end-date-year`"
                v-validate="'required'"
                data-vv-as="end-date-year"
                class="form-control form-control-inline"
                :class="{
                  'is-invalid':
                    errors.has(`formSelect2.end-date-year`) || yearErr,
                }"
                @click="resetErr"
                v-model="formSelect2.endYear"
              >
                <option value>年份</option>
                <option
                  v-for="(opt, y_opt_i) in yearOpt"
                  :key="`end-year-${y_opt_i}`"
                  :value="opt"
                >
                  {{ opt - 1911 }}年
                </option>
              </select>

              <span class="text">/</span>

              <select
                :id="`end-date-month`"
                :data-vv-name="`end-date-month`"
                v-validate="'required'"
                data-vv-as="end-date-month"
                class="form-control form-control-inline"
                :class="{
                  'is-invalid':
                    errors.has(`formSelect2.end-date-month`) || monthErr,
                }"
                v-model="formSelect2.endMonth"
                @click="resetErr"
              >
                <option value>月份</option>
                <option
                  v-for="(opt, m_opt_i) in monthOpt"
                  :key="`end-month-${m_opt_i}`"
                  :value="opt"
                >
                  {{ opt }}月
                </option>
              </select>
            </div>
            <button
              type="button"
              class="btn btn-primary"
              style="height: 45px"
              @click="doQuery('date')"
            >
              查詢
            </button>
          </div>
        </form>
        <br />
        <!-- 資料呈現區塊 -->
        <table
          id="bullentin_datatable"
          class="table datatable table-striped area-list-datatable"
        >
          <thead>
            <tr>
              <th>#</th>
              <th
                id="ID"
                :class="
                  'sorting ' +
                  (order.fieldName == 'ID'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('ID')"
                class="text-center"
              >
                客戶 ID
              </th>
              <th
                id="NAME"
                :class="
                  'sorting ' +
                  (order.fieldName == 'NAME'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('NAME')"
              >
                客戶姓名
              </th>
              <th
                id="FORM_NO"
                :class="
                  'sorting ' +
                  (order.fieldName == 'FORM_NO'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('FORM_NO')"
              >
                表單編號
              </th>
              <th
                id="MEMO"
                :class="
                  'sorting ' +
                  (order.fieldName == 'MEMO'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('MEMO')"
              >
                備註
              </th>
              <th
                id="EMP_NAME"
                :class="
                  'sorting ' +
                  (order.fieldName == 'EMP_NAME'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('EMP_NAME')"
              >
                輸入人員
              </th>
              <th
                id="DIV_SHORT_NAME"
                :class="
                  'sorting ' +
                  (order.fieldName == 'DIV_SHORT_NAME'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('DIV_SHORT_NAME')"
              >
                輸入人員單位
              </th>
              <th
                id="CREATE_TIME"
                :class="
                  'sorting ' +
                  (order.fieldName == 'CREATE_TIME'
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                "
                @click="processList('CREATE_TIME')"
              >
                輸入日期
              </th>
            </tr>
          </thead>
          <tbody id="bullentin-view" v-if="rtnList.length > 0">
            <tr
              v-for="(item, index) in rtnList"
              :key="`td-rtnList-${index}-${item.ID}`"
            >
              <td>{{ index + 1 }}</td>
              <td>
                <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.NAME"
                      :id="item.ID"
                      expand_col1="備註"
                      :expand_col1_value="item.MEMO"
                      expand_col2="輸入人員"
                      :expand_col2_value="item.EMP_NAME"
                    >
                    {{ item.ID | getMaskID}}
                </Tooltip>
              </td>
              <td>{{ item.NAME | getMaskName}}</td>
              <td>{{ item.FORM_NO }}</td>
              <td>{{ item.MEMO | getMaskID}}</td>
              <td>{{ item.EMP_NAME | getMaskName}}</td>
              <td>{{ item.DIV_SHORT_NAME }}</td>
              <td class="text-center">
                <div class="date">{{ item.CREATE_TIME | dateFormat }}</div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="13" class="empty">
                <h3 class="text-center py-5">無任何資料</h3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import {
  insertDiffWord,
  updateDiffWord,
  deleteDiffWord,
  updateSingleDiffWord,
  queryDiffWord,
} from "@/service";
import { commonMixin } from "@/mixins/common";
import Tooltip from "@/desktop/components/ToolTip";

export default {
  name: "diffWordPropertyLiability",
  mixins: [commonMixin],
  components: {
    Tooltip,
  },
  data() {
    return {
      ajaxLoading1: false, // 避免重複查詢
      ajaxLoading2: false, // 避免重複查詢
      ajaxLoading3: false, // 避免重複查詢
      ajaxLoading4: false, // 避免重複查詢
      ajaxLoading5: false, // 避免重複查詢
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      yearOpt: [],
      formInsert: {
        ID: "",
        NAME: "",
        FORM_NO: "",
        MEMO: "",
      },
      formUpdate: {
        ID: "",
        NAME: "",
        FORM_NO: "",
        MEMO: "",
      },
      formDelete: {
        ID: "",
      },
      formUpdateSingle: {
        ID: "",
      },
      formSelect1: {
        ID: "",
      },
      formSelect2: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      yearErr: false,
      monthErr: false,
      order: {
        fieldName: "name",
        asc: true,
      },
      rtnList: [],
    };
  },
  methods: {
    resetValid() {
      this.$validator.reset();
    },
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "create_time":
          setTimeout(() => {
            this.rtnList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.rtnList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function (a, b) {
        const ar = a[property] ? a[property] : "";
        const br = b[property] ? b[property] : "";
        let result = ar < br ? -1 : ar > br ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function (a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    doInsert() {
      if (this.ajaxLoading1) {
        return;
      }
      this.ajaxLoading1 = true;
      this.$validator.validateAll("formInsert").then((el) => {
        if (!el) {
          return;
        }

        let policyList = [];
        for (var i = 1; i <= 5; i++) {
          let tmpStr = "POLICY_NO" + i;
          if (this.formInsert[tmpStr]) {
            policyList.push(this.formInsert[tmpStr]);
          }
        }

        let insertData = {
          ID: this.formInsert.ID,
          NAME: this.formInsert.NAME,
          FORM_NO: this.formInsert.FORM_NO,
          MEMO: this.formInsert.MEMO,
        };

        this.$validator.reset();
        insertDiffWord(
          this.$store.state.userInfo.id,
          insertData,
          policyList
        ).then((result) => {
          this.$toast.info({ title: result.header.message });
        });
      });
      this.ajaxLoading1 = false;
    },
    doUpdate() {
      if (this.ajaxLoading2) {
        return;
      }
      this.ajaxLoading2 = true;
      this.$validator.validateAll("formUpdate").then((el) => {
        if (!el) {
          return;
        }

        let updateData = {
          ID: this.formUpdate.ID,
          NAME: this.formUpdate.NAME,
          FORM_NO: this.formUpdate.FORM_NO,
          MEMO: this.formUpdate.MEMO,
        };

        this.$validator.reset();
        updateDiffWord(this.$store.state.userInfo.id, updateData).then(
          (result) => {
            this.$toast.info({ title: result.header.message });
          }
        );
      });
      this.ajaxLoading2 = false;
    },
    doDelete() {
      if (this.ajaxLoading3) {
        return;
      }
      this.ajaxLoading3 = true;
      this.$validator.validateAll("formDelete").then((el) => {
        if (!el) {
          return;
        }

        let deleteData = {
          ID: this.formDelete.ID,
        };

        this.$validator.reset();
        deleteDiffWord(this.$store.state.userInfo.id, deleteData).then(
          (result) => {
            this.$toast.info({ title: result.header.message });
          }
        );
      });
      this.ajaxLoading3 = false;
    },
    doUpdateSingle() {
      if (this.ajaxLoading4) {
        return;
      }
      this.ajaxLoading4 = true;
      this.$validator.validateAll("formUpdateSingle").then((el) => {
        if (!el) {
          return;
        }

        let updateSingleData = {
          ID: this.formUpdateSingle.ID,
        };

        this.$validator.reset();
        updateSingleDiffWord(
          this.$store.state.userInfo.id,
          updateSingleData
        ).then((result) => {
          this.$toast.info({ title: result.header.message });
        });
      });
      this.ajaxLoading4 = false;
    },

    doQuery(type) {
      let queryData;

      if (this.ajaxLoading5) {
        return;
      }
      this.ajaxLoading5 = true;
      if (type === "ID") {
        this.$validator.validateAll("formSelect1").then((el) => {
          if (!el) {
            return;
          }

          queryData = this.formSelect1;
          queryDiffWord(this.$store.state.userInfo.id, queryData).then(
            (result) => {
              this.rtnList = result.body || [];
              this.$toast.info({ title: result.header.message });
            }
          );
        });
      } else {
        this.$validator.validateAll("formSelect2").then((el) => {
          if (!el) {
            return;
          }

          if (this.formSelect2.startYear > this.formSelect2.endYear) {
            this.yearErr = true;
            this.monthErr = true;
            this.$toast.info({ title: "查詢日期起始日不可大於結束日" }); //印出檢核後的錯誤訊息
            return;
          } else if (
            this.formSelect2.startYear == this.formSelect2.endYear &&
            this.formSelect2.startMonth > this.formSelect2.endMonth
          ) {
            this.monthErr = true;
            this.$toast.info({ title: "查詢日期起始日不可大於結束日" }); //印出檢核後的錯誤訊息
            return;
          }
          let startDate = ""; //查詢的起始日
          let endDate = ""; //查詢的結束日
          let lastDay = ""; //每月最後一天

          lastDay = new Date(
            this.formSelect2.endYear,
            parseInt(this.formSelect2.endMonth),
            0
          ).getDate();
          startDate = `${this.formSelect2.startYear}-${this.formSelect2.startMonth}-01`;
          endDate = `${this.formSelect2.endYear}-${this.formSelect2.endMonth}-${lastDay}`;

          queryData = { startDate, endDate };
          queryDiffWord(this.$store.state.userInfo.id, queryData).then(
            (result) => {
              this.rtnList = result.body || [];
              this.$toast.info({ title: result.header.message });
            }
          );
        });
      }

      this.ajaxLoading5 = false;
    },

    resetErr() {
      this.yearErr = false;
      this.monthErr = false;
    },
  },
  watch: {
    rtnList: function () {
      this.registerHanlink();
    },
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
    this.formSelect2.startYear = window.moment().year();
    this.formSelect2.startMonth = window.moment().month();
    this.formSelect2.endYear = window.moment().year();
    this.formSelect2.endMonth = window.moment().month();
  },
};
</script>
<style lang="scss" scoped>
.note {
  margin-bottom: 0.5rem;
  line-height: 1.5;
  font-weight: 600;
}
</style>
